import React from 'react'
import { Registation } from '../../containers'
import { ToastContainer } from 'react-toastify'
import { CircularProgress } from '@mui/material'
import { useSelector } from 'react-redux'

const RegistrationPage = () => {
   const { loader, openImport, inExpense, creditOpen } = useSelector((state) => state.global)
  return (
    <>
      {loader && (
            <div className="circular-box" style={{ height: inExpense ? '100dvh' : '100dvh' }}>
              <CircularProgress />
            </div>
          )}
      <Registation />
      <ToastContainer />
    </>
  )
}

export default RegistrationPage
